import React from 'react';
import API from 'files/api.js';

const buildRequest = (url, props) => {
    let newURL = `${url}?type=${props.type}`;
    for(var i in props) {
        if(i == 'type') {
            continue;
        }
        newURL += `&${i}=${typeof(props[i]) === 'object' ? JSON.stringify(props[i]) : encodeURIComponent(props[i])}`;
    }
    return newURL;
}

const Request = {
    get: async (utils, url, props) => {
        return new Promise(async (resolve, reject) => {
            try {
                // build and send request
                let response = await fetch(buildRequest(`/api/v${API.version}${url}`, props), {
                    method: 'GET',
                    withCredentials: true,
                    headers: utils.api.headers()
                });

                // prevent moving forward if any other status than success is returned
                if(response.status !== 200) {
                    let text = await response.text();
                    throw new Error(text || 'An unknown error occurred');
                    return;
                }

                // parse json response body and resolve
                let json = await response.json();
                resolve(json);

            } catch(e) {
                reject(e);
            }
        })
    },
    post: async (utils, url, props) => {
        return new Promise(async (resolve, reject) => {
            try {
                // build and send request
                let response = await fetch(`/api/v${API.version}${url}`, {
                    method: 'POST',
                    withCredentials: true,
                    headers: utils.api.headers(),
                    body: JSON.stringify(props)
                });

                // check for conflicts and allow user to respond
                if(response.status === 409) {
                    let json = await response.json();
                    let error = new Error();
                    error.code = response.status;
                    error.message = json.message;
                    error.response = json;
                    throw error;
                    return;
                }

                // prevent moving forward if any other status than success is returned
                if(response.status !== 200) {
                    let text = await response.text();
                    throw new Error(text || 'An unknown error occurred');
                    return;
                }

                // parse json response body and resolve
                let json = await response.json();
                resolve(json);

            } catch(e) {
                reject(e);
            }
        })
    }
}
export default Request;
